// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","445":"1bfc9850","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"c4e11fa85d1a91c5901f","445":"97b132a6addf1bc70f35","691":"7f21fb46bb979c321467"}[chunkId] + ".js";
};